import { createTheme, globalTheme } from '@cld/component-theme';

export const theme = createTheme({
  padding: {
    vertical: globalTheme.spacing.xs,
    horizontal: globalTheme.spacing.md,
  },
  focus: {
    boxShadow: {
      sizes: '0px 0px 0px 3px',
      baseColor: globalTheme.palette.primary,
    },
  }
});
